import _asyncToGenerator from "F:/vue2.0+ vant/2024\u5E74\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u5B98\u7F51\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u4E2D\u6587\u7248\u672C/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { ref, onMounted } from "vue";
import { getHomeCorporateAdvantageList_url } from '@/api'; //引入发送请求获取数据的方法

export default {
  components: {},
  name: "advantage",
  setup: function setup() {
    var porateAdvantageList = ref([]); //获取企业优势列表

    function getHomeCorporateAdvantageList() {
      return _getHomeCorporateAdvantageList.apply(this, arguments);
    }

    function _getHomeCorporateAdvantageList() {
      _getHomeCorporateAdvantageList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getHomeCorporateAdvantageList_url();

              case 2:
                result = _context.sent;

                if (result.code == 200) {
                  porateAdvantageList.value = result.data;
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getHomeCorporateAdvantageList.apply(this, arguments);
    }

    onMounted(function () {
      getHomeCorporateAdvantageList();
    });
    var showMore = ref(false);
    var activeNames = ref(-1);
    var showMoreBtnState = ref(-1);

    var toggleMore = function toggleMore(val) {
      showMore.value = true;
      activeNames.value = val;
      showMoreBtnState.value = val;
    };

    var retract = function retract(name) {
      activeNames.value = -1;
      showMoreBtnState.value = -1; // console.log(activeNames.value,'看看是什么');

      showMore.value = false;
    };

    return {
      activeNames: activeNames,
      porateAdvantageList: porateAdvantageList,
      showMore: showMore,
      retract: retract,
      toggleMore: toggleMore,
      showMoreBtnState: showMoreBtnState
    };
  }
};